import React, { useEffect, useState } from 'react'
import Svg from '../../../../../../../component/common/Svg'
import QuestionDropdown from './QuestionDropdown'
import MultipleChoicePreview from './previews/multiple_choice/MultipleChoicePreview'
import TextPreview from './previews/text/TextPreview'
import OpinionScalePreview from './previews/opinion_scale/OpinionScalePreview'
import { useDispatch } from 'react-redux'
import { deleteQuestion, duplicateQuestion, updateQuestionText, updateQuestionType } from '../../../../../../../store/actions/qnaBuilderAction'
import style from "../../../../../../style.module.css"
import Card from "../../../../../../../core/Card"
import { CKEditor } from '@ckeditor/ckeditor5-react';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import Input from "../../../../../../../core/Inputs/DefaultInput";
import { useFormik } from 'formik';
import * as Yup from 'yup';
import { useTranslation } from 'react-i18next';



const SectionQuestion = ({
    
    question, questionId, survey_id, language_code, questionIndex, provided
}) => {
    //State
    const { t, i18n } = useTranslation();
    const collapseModes = {
        preview: t('survey.builder.preview'),
        edit: t('survey.builder.edit'),
    }
    const [questionData, setQuestionData] = useState(null)
    const [currentOption, setCurrentOption] = useState(null)
    const [tmpOption, setTmpOption] = useState(null)
    const [isVisibleCollapse, setIsVisibleCollapse] = useState(false)
    const [editor, setEditor] = useState(null)
    const [collapseMode, setCollapseMode] = useState(window.modulePermissions.M11.edit == 1 ? collapseModes.edit : collapseModes.preview)
    const dispatch = useDispatch()
  

    //Options
    const options = [
        {
            value: '1',
            name: t('survey.question.multi'),
            svg: 'multiple-choice'
        },
        // {
        //     value: '2',
        //     name: t('survey.question.text'),
        //     svg: 'text-icon'
        // },
        // {
        //     value: '3',
        //     name: t('survey.question.scale'),
        //     svg: 'opinion-scale'
        // },
    ]

    //==> FORM SCHEMA AND VALIDATION <==

    //Yup
    const formSchema = Yup.object().shape({
        title: Yup.string().trim().required('Question required'),
    })

    //Formik
    const initialValues = {
        title: '',
    }

    const formik = useFormik({
        initialValues: initialValues,
        validationSchema: formSchema,
    })

    const { values, handleChange, handleBlur, touched, errors, setFieldValue } = formik


    //Functionalities
    const toggleCollapse = () => {
        if (currentOption) {
            setIsVisibleCollapse(!isVisibleCollapse)
        }
    }

    const startEditMode = () => {
        if (currentOption) {
            setIsVisibleCollapse(true)
            setCollapseMode(collapseModes.edit)
        }
    }

    const handleChangeOption = (option) => {
        const payload = {
            su_question_type: option?.value,
            question_id: questionId
        }
        dispatch(updateQuestionType(payload))
    }

    const handleDeleteQuestion = (questionId) => {
        const payload = {
            qid: questionId,
        }
        dispatch(deleteQuestion(payload))
    }

    const handleDuplicateQuestion = (question_id) => {
        const payload = {
            question_id: question_id
        }
        dispatch(duplicateQuestion(payload))
    }

    const handleUpdateQuestionText = (id, text) => {
        const payload = {
            language_code: language_code,
            id,
            text
        }
        dispatch(updateQuestionText(payload))
    }

    const handleBlurQuestionText = (e, { questionId }, text) => {
        handleBlur(e)
        if (text && text.trim()) {
            handleUpdateQuestionText(questionId, text)
        }
    }

    //Effects
    useEffect(() => {
        if (question) {
            let tmpData = {
                options: question.su_options && JSON.parse(question.su_options),
                orderNo: question.su_order_no,
                questionId: question.su_question_id,
                questionText: question.su_question_text && JSON.parse(question.su_question_text)[language_code],
                questionHint: question.su_question_hint && JSON.parse(question.su_question_hint)[language_code],
                questionType: question.su_question_type,
                sectionId: question.su_section_id,
                required: question.su_is_required,
                isScore: question.su_is_score,
                opinionRange: question.su_opinion_range && isNaN(question.su_opinion_range) && JSON.parse(question.su_opinion_range ?? {}),
                opinionIcon: question.su_opinion_icon
            }
            setCurrentOption(options.filter((opt) => Number(opt.value) === Number(tmpData.questionType))[0])
            setQuestionData(tmpData)
        }
    }, [language_code, question])

    useEffect(() => {
        setFieldValue('title', questionData?.questionText ?? '')
    }, [questionData])

    if (!question) {
        return null;
    }
    
    return (
        <>
            <div
                className="accordion-item pb-0 pt-0 mb__20"
                key={questionId}
                ref={provided.innerRef}
                {...provided.draggableProps}
            >
                <h2 className="accordion-header new-accord-header" id="heading11">
                    <div
                        className="accordion-button"
                        type="button"
                        onClick={() => toggleCollapse()}
                        aria-expanded="true"
                    >
                        <div className='accordianLeft-sec d-flex align-items-center me-4 position-relative flex-grow-1'>
                            <div className='acc-no'>{t('survey.question.q')} {questionIndex}</div>
                            <div className="flex-grow-1">


                                {(!isVisibleCollapse || (isVisibleCollapse && collapseMode === collapseModes.preview)) && <div className="text">{questionData?.questionText}</div>}
                                {(isVisibleCollapse && collapseMode === collapseModes.edit) &&
                                    <>
                                        <div className="text">
                                            <Input
                                                type="text"
                                                view="outlined"
                                                color="default"
                                                label=""
                                                placeholder= {t('survey.question.enter')}
                                                value={values.title}
                                                onClick={((e) => e.stopPropagation())}
                                                fill
                                                name='title'
                                                onChange={window.modulePermissions.M11.edit == 1 ? handleChange : undefined}
                                                onBlur={window.modulePermissions.M11.edit == 1 ? (e) => { handleBlurQuestionText(e, questionData, values.title) } : undefined}
                                                readOnly={window.modulePermissions.M11.edit != 1}
                                                className={"formsinput " + style.card__exp}
                                            />
                                            {touched.title && errors.title && <div className='validation-msg'>{errors.title}</div>}
                                        </div>
                                    </>
                                }

                                {/* QUESTION HINT */}

                                {/* {<div className="text" onClick={(e) => { e.stopPropagation() }}>
                                <CKEditor
                                    key={questionId}
                                    editor={ClassicEditor}
                                    config={{
                                        removePlugins: ["EasyImage", "ImageUpload", "MediaEmbed", "Table", "TableToolbar"]
                                    }}
                                    onReady={editor => {
                                        setEditor(editor)
                                    }}
                                    onChange={(event, editor) => {
                                        let data = editor.getData();
                                        // data = htmlEncode(data)
                                        // setFieldValue(`assign.${index}.value`, data)
                                    }}
                                    onBlur={(event, editor) => {
                                        // setFieldTouched(`assign.${index}.value`, true)
                                    }}
                                />
                            </div>} */}
                            </div>
                        </div>
                    </div>
                    <div className="d-flex align-items-center justify-content-end question-right-side">
                        {window.modulePermissions.M11.edit == 1 && <QuestionDropdown
                            options={options}
                            index={questionId}
                            currentOption={currentOption}
                            setCurrentOption={setCurrentOption}
                            tmpOption={tmpOption}
                            setTmpOption={setTmpOption}
                            handleChange={handleChangeOption}
                        />}
                        <div className="action-wrapper d-flex edit-delete">
                            {window.modulePermissions.M11.edit == 1 && (<button title= {t('survey.question.editq')} className='action-btn btn-edit' onClick={() => startEditMode()}>
                                <Svg name="edit" />
                            </button>)}
                            {window.modulePermissions.M11.del == 1 && (
                            <button
                                className='action-btn delete'
                                data-bs-toggle="modal"
                                title={t('survey.question.del1')}
                                data-bs-target={`#delete-question${questionId}`}>
                                <Svg name="section-delete" />
                            </button>
                            )}
                            {window.modulePermissions.M11.add == 1 && (<button
                                className='action-btn copy'
                                title={t('survey.question.duplicateq')}
                                onClick={() => handleDuplicateQuestion(questionId)}
                            >
                                <Svg name="duplicate-section" />
                            </button>)}
                            {window.modulePermissions.M11.edit == 1 && (<button
                                className='action-btn draggable'
                                title={t('survey.question.recorder')}
                                {...provided.dragHandleProps} >
                                <Svg name="draggable" />
                            </button>)}
                        </div>
                    </div>
                </h2 >

                {
                    (Number(currentOption?.value) === 1) && <MultipleChoicePreview
                        isVisibleCollapse={isVisibleCollapse}
                        setIsVisibleCollapse={setIsVisibleCollapse}
                        collapseModes={collapseModes}
                        collapseMode={collapseMode}
                        setCollapseMode={setCollapseMode}
                        question={questionData}
                        questionIndex={questionIndex}
                        language_code={language_code}
                        questionId={questionId}
                        survey_id={survey_id}
                    />
                }
                {
                    (Number(currentOption?.value) === 2) && <TextPreview
                        isVisibleCollapse={isVisibleCollapse}
                        setIsVisibleCollapse={setIsVisibleCollapse}
                        collapseModes={collapseModes}
                        collapseMode={collapseMode}
                        setCollapseMode={setCollapseMode}
                        question={questionData}
                        questionIndex={questionIndex}
                        language_code={language_code}
                        questionId={questionId}
                        survey_id={survey_id}
                    />
                }
                {
                    (Number(currentOption?.value) === 3) && <OpinionScalePreview
                        isVisibleCollapse={isVisibleCollapse}
                        setIsVisibleCollapse={setIsVisibleCollapse}
                        collapseModes={collapseModes}
                        collapseMode={collapseMode}
                        setCollapseMode={setCollapseMode}
                        question={questionData}
                        questionIndex={questionIndex}
                        language_code={language_code}
                        questionId={questionId}
                        survey_id={survey_id}
                    />
                }
            </div >

            <div className="customvar-modal modal custom-modal fade deleteModal" id={`delete-question${questionId}`} tabIndex={-1} aria-labelledby="changeModalLabel" aria-hidden="true">
                <div className="modal-dialog modal-dialog-centered">
                    <div className="modal-content">
                        <div className="modal-body">
                            <div className={"formcontainer " + style.container}>
                                <div className={"formvawrapper delete-modal-wrap modal-sm " + style.wrapper}>
                                    <Card view="raised" className={"formstyle p-0 " + style.card} >
                                        <div className="delete-header d-flex align-items-center">
                                            <div className="icon">
                                                <Svg name="exclamation" />
                                            </div>
                                            <div className="media-body ps-3">
                                                <h4 className='mb-0'>{t('survey.question.del1')}</h4>
                                            </div>
                                        </div>
                                        <div className="delete-body-wrap">
                                            <div className="change-field-wrap p-0 mb-4">
                                                <div className="subtitle text-center">{t('survey.question.del2')}</div>
                                            </div>
                                            <div className="button-wrap d-flex justify-content-center">
                                                <button type="button" className="btn btn-bordered color-cancel" data-bs-dismiss="modal">{t('settings.team.create_team.cancel')}</button>
                                                <button type="button" className="btn btn-delete ms-3" data-bs-dismiss="modal" onClick={() => handleDeleteQuestion(questionId)}>{t('survey.customVariable.confirm_delete')}</button>
                                            </div>
                                        </div>
                                    </Card>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default SectionQuestion